export const MAX_TAB_COUNT = 10
